<template>
  <el-dialog
    :title="$t('deleteDownloadTempFile.confirmTitle')"
    :visible.sync="dialogVisible"
    width="30%"
    center
  >
    <div style="text-align: center">
      <p>{{ $t('deleteDownloadTempFile.confirmText') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">
        {{ $t('deleteDownloadTempFile.cancel') }}
      </el-button>
      <el-button type="primary" @click="confirmDelete">
        {{ $t('deleteDownloadTempFile.confirm') }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteUserDownloadFile } from '@/api/property/downloadTempFileApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteDownloadTempFile',
  data() {
    return {
      dialogVisible: false,
      currentFile: null
    }
  },
  methods: {
    open(file) {
      this.currentFile = file
      this.dialogVisible = true
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async confirmDelete() {
      try {
        const params = {
          ...this.currentFile,
          shopId: getShopId()
        }
        await deleteUserDownloadFile(params)
        this.$message.success(this.$t('deleteDownloadTempFile.deleteSuccess'))
        this.$emit('refresh')
        this.closeDialog()
      } catch (error) {
        console.error('删除文件失败:', error)
        this.$message.error(this.$t('deleteDownloadTempFile.deleteFailed'))
      }
    }
  }
}
</script>